import styled from '@emotion/styled';
import { Box as MuiBox, Chip } from '@mui/material';

export const FormStyle = styled(MuiBox)`
  ${() => `
  padding-left: 0.875rem;
  padding-right: 0.875rem;
  height: calc(100vh - 130px)
  `}
`;

export const TimePickerStyle = styled(MuiBox)`
  ${() => `
    padding-top: 15px;
    padding-bottom: 15px;
  `}
`;

export const RightWrap = styled(MuiBox)`
  ${() => `width: -webkit-fill-available;

  [data-testid='trigger'] {
    width: -webkit-fill-available;
  }

  div.MuiStack-root {
    width: -webkit-fill-available;
    button:nth-child(2) {
      width: -webkit-fill-available;
    }
   }
  `}
`;

export const GridStyle = styled(MuiBox)`
  ${({ theme }) => `
    alignItems: center;
    height: calc(100vh - 14rem);

    .MuiDataGrid-row.voided {
      background: ${theme?.validateMode ? theme.validateMode({ light: '#FFF6F7', dark: '#492532' }) : '#FFF6F7'};
      cursor: default;

      &:hover,
      &.Mui-hovered {
        background: ${theme?.validateMode ? theme.validateMode({ light: '#FFF6F7', dark: '#633B48' }) : '#FFF6F7'};
      }

      &.Mui-selected {
        background: ${theme?.validateMode ? theme.validateMode({ light: '#FFF6F7', dark: '#986977' }) : '#FFF6F7'};
      }
    }
  `}
`;

export const StatusChip = styled(Chip, {
  shouldForwardProp: prop => prop !== 'voided',
})(
  ({ theme, voided }) => `
    font-weight: 500;
    border-radius: 0.5rem;
    min-width: 5.1875rem;
    color: ${
      voided
        ? theme?.validateMode
          ? theme.validateMode({ light: theme.colorsCA.red[60], dark: theme.colorsCA.neutral[100] })
          : '#C62828'
        : theme?.validateMode
        ? theme.validateMode({ light: '#005D29', dark: theme.colorsCA.neutral[100] })
        : '#005D29'
    };
    background: ${
      voided
        ? theme?.validateMode
          ? theme.validateMode({ light: '#FDEAEC', dark: '#31191B' })
          : '#FDEAEC'
        : theme?.validateMode
        ? theme.validateMode({ light: '#E6F5EB', dark: '#142F22' })
        : '#E6F5EB'
    };
  `
);
